import logo from '../../assets/img/ghost.png'
export const LandingBg = () => {
    return (
        <div className="loading-scr">
            <div className="loading-animation">
                <img src={logo} alt="ghost" />
                <div className="load-bar"></div>
            </div>
        </div>
    )
}
